import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import WelcomeHeader from './components/WelcomeHeader';
import BannerSection from './components/BannerSection';
import BenefitSection from './components/BenefitSection';
import ImpactSection from './components/ImpactSection';
import TestimonialSection from './components/TestimonialSection';
import PartnerSection from './components/PartnerSection';
import { getHomepageData } from './Action';
import { toast } from 'react-toastify';
import { Box, CircularProgress } from '@mui/material';

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });

  useEffect(() => {
    //  Clearing all the store reducers
    dispatch({ type: 'Single_Invoice', data: null });
    dispatch({ type: 'SHOW_TRANSACTIONS', data: null });
    dispatch({ type: 'SET_INVOICE_PRODS', data: [] });
    dispatch({ type: 'SET_BUYER', data: {} });
  }, []);

  useEffect(() => {
    if (!loginUser) {
      navigate('/', { replace: true });
      return;
    }
  }, [loginUser]);
  const [homeData, setHomeData] = useState({});
  const [loading, setLoading] = useState(false);
  const user_id = loginUser ? loginUser.user_id : null;
  const getHomeData = async () => {
    setLoading(true);
    const { error, message, data } = await getHomepageData(user_id);
    setLoading(false);
    if (!error) {
      setHomeData(data);
    } else {
      toast.error(message);
    }
  };
  useEffect(() => {
    getHomeData();
  }, [loginUser]);
  const { welcome, banner, benefits, impact, testimonials, partners } =
    homeData;

  return (
    <div>
      {loading ? (
        <Box
          sx={{
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          {/* { !loginUser && <TopNav /> } */}
          <WelcomeHeader header={welcome} />
          <BannerSection content={banner} />
          <BenefitSection benefits={benefits} />
          <ImpactSection impact={impact} />
          <TestimonialSection testimonials={testimonials} />
          <PartnerSection partners={partners} />
        </>
      )}
    </div>
  );
};

export default Home;
